import _styled from "styled-components";
var _SearchIcon;
import SearchIcon from "@crehana/icons/outline/Search";
import { TEXT_FIELD_BACKGROUND_COLOR_CLASSNAMES, TEXT_FIELD_BORDER_COLOR_CLASSNAMES, TEXT_FIELD_HINT_COLOR_CLASSNAMES
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
} from "@crehana/ui";
import cn from "classnames";
import { useMainMenuContext, useMainMenuTranslation } from "../../MainMenu/hooks";
import NavbarIconButton from "../../MainMenu/ui/NavbarIconButton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Search = function Search() {
  var _useMainMenuTranslati = useMainMenuTranslation(),
    t = _useMainMenuTranslati.t;
  var _useMainMenuContext = useMainMenuContext(),
    theme = _useMainMenuContext.theme,
    themeName = _useMainMenuContext.themeName,
    currentBreakpointKey = _useMainMenuContext.currentBreakpointKey,
    onDashboardSearchClick = _useMainMenuContext.onDashboardSearchClick;
  if (currentBreakpointKey === 'xs' || currentBreakpointKey === 'sm') {
    return /*#__PURE__*/_jsx(NavbarIconButton, {
      Icon: SearchIcon,
      onClick: onDashboardSearchClick,
      label: t('SEARCH_LABEL')
    });
  }
  return /*#__PURE__*/_jsxs(_StyledButton, {
    type: "button",
    "data-cy": "dashboard-search",
    className: cn('font-body4 h-40 px-16 flex items-center border border-solid rounded-5', TEXT_FIELD_BORDER_COLOR_CLASSNAMES[themeName.searchInput], TEXT_FIELD_BACKGROUND_COLOR_CLASSNAMES[themeName.searchInput], TEXT_FIELD_HINT_COLOR_CLASSNAMES[themeName.searchInput]),
    onClick: onDashboardSearchClick,
    $_css: theme.searchInput.width,
    children: [_SearchIcon || (_SearchIcon = /*#__PURE__*/_jsx(SearchIcon, {
      size: 24,
      ignoreColor: true,
      className: "fill-current"
    })), /*#__PURE__*/_jsx("span", {
      className: "hidden ml-8 md:inline-flex",
      children: t('DASHBOARD_SEARCH_HINT')
    })]
  });
};
export default Search;
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  componentId: "sc-1saxgab-0"
})(["\n        width: ", "px;\n      "], function (p) {
  return p.$_css;
});